import { render, staticRenderFns } from "./myBookingList.vue?vue&type=template&id=2c70611a&"
import script from "./myBookingList.vue?vue&type=script&lang=js&"
export * from "./myBookingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports